/**
 * Tilled Internal API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportColumnDefinition { 
    column: string;
    description: string;
    grouping: ReportColumnDefinition.GroupingEnum;
}
export namespace ReportColumnDefinition {
    export type GroupingEnum = 'customer details' | 'payment details' | 'payment method details' | 'payout details' | 'reseller details' | 'software platform details' | 'subscription details' | 'terminal details';
    export const GroupingEnum = {
        CUSTOMER_DETAILS: 'customer details' as GroupingEnum,
        PAYMENT_DETAILS: 'payment details' as GroupingEnum,
        PAYMENT_METHOD_DETAILS: 'payment method details' as GroupingEnum,
        PAYOUT_DETAILS: 'payout details' as GroupingEnum,
        RESELLER_DETAILS: 'reseller details' as GroupingEnum,
        SOFTWARE_PLATFORM_DETAILS: 'software platform details' as GroupingEnum,
        SUBSCRIPTION_DETAILS: 'subscription details' as GroupingEnum,
        TERMINAL_DETAILS: 'terminal details' as GroupingEnum
    };
}


